import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div style={styles.container}>
          <div style={styles.card}>
            <i className="pi pi-exclamation-triangle" style={styles.icon}></i>
            <h2 style={styles.title}>Something went wrong</h2>
            <p style={styles.message}>
              An unexpected error occurred. Please try again or contact support if the problem persists.
            </p>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details style={styles.details}>
                <summary style={styles.summary}>Error Details</summary>
                <pre style={styles.errorText}>
                  {this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
            <div style={styles.actions}>
              <button
                onClick={this.handleRetry}
                style={styles.retryButton}
                className="p-button p-button-primary"
              >
                <i className="pi pi-refresh" style={{ marginRight: '8px' }}></i>
                Try Again
              </button>
              <button
                onClick={() => { window.location.hash = '/'; window.location.reload(); }}
                style={styles.homeButton}
                className="p-button p-button-secondary"
              >
                <i className="pi pi-home" style={{ marginRight: '8px' }}></i>
                Go Home
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '400px',
    padding: '40px 20px',
  },
  card: {
    textAlign: 'center',
    maxWidth: '500px',
    padding: '40px',
    borderRadius: '8px',
    backgroundColor: '#ffffff',
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
  },
  icon: {
    fontSize: '48px',
    color: '#e74c3c',
    marginBottom: '16px',
  },
  title: {
    color: '#333',
    marginBottom: '12px',
    fontSize: '24px',
  },
  message: {
    color: '#666',
    lineHeight: '1.5',
    marginBottom: '24px',
  },
  details: {
    textAlign: 'left',
    marginBottom: '24px',
    padding: '12px',
    backgroundColor: '#f8f9fa',
    borderRadius: '4px',
  },
  summary: {
    cursor: 'pointer',
    color: '#666',
    fontWeight: 'bold',
  },
  errorText: {
    fontSize: '12px',
    color: '#e74c3c',
    overflow: 'auto',
    maxHeight: '200px',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  actions: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
  },
  retryButton: {
    cursor: 'pointer',
  },
  homeButton: {
    cursor: 'pointer',
  },
};

export default ErrorBoundary;
